// Author YuJiaBei
// Date 2020-11-10 11:33:21

class SithMesPrdRoutingSummaryDetail {
constructor({
        id = null,
        prdRoutingSummaryCode = '',
        mstLocationId = '',
        workHour = '',
        seq = '',
        bufferHour = '',
        transferHour = '',
        unit = '',
        quantity = '',
        sapChangedFlag = '',
        description = '',
        remark = ''}
= {}) {
    this.id = id;
    this.prdRoutingSummaryCode = prdRoutingSummaryCode;
    this.mstLocationId = mstLocationId;
    this.workHour = workHour;
    this.seq = seq;
    this.bufferHour = bufferHour;
    this.transferHour = transferHour;
    this.unit = unit;
    this.quantity = quantity;
    this.sapChangedFlag = sapChangedFlag;
    this.description = description;
    this.remark = remark;
}
}

function newEntity() {
return new SithMesPrdRoutingSummaryDetail();
}

    function gridFields() {
    return Object.freeze([
        {
        key: 'prdRoutingSummaryCode',
        label: 'label.sith.prd.sithMesPrdRoutingSummaryDetail.grid.prdRoutingSummaryCode',
        sortable: true,
            isDetail: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'mstLocationId',
        label: 'label.sith.prd.sithMesPrdRoutingSummaryDetail.grid.mstLocationId',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'workHour',
        label: 'label.sith.prd.sithMesPrdRoutingSummaryDetail.grid.workHour',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'seq',
        label: 'label.sith.prd.sithMesPrdRoutingSummaryDetail.grid.seq',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'bufferHour',
        label: 'label.sith.prd.sithMesPrdRoutingSummaryDetail.grid.bufferHour',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'transferHour',
        label: 'label.sith.prd.sithMesPrdRoutingSummaryDetail.grid.transferHour',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'unit',
        label: 'label.sith.prd.sithMesPrdRoutingSummaryDetail.grid.unit',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'quantity',
        label: 'label.sith.prd.sithMesPrdRoutingSummaryDetail.grid.quantity',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'sapChangedFlag',
        label: 'label.sith.prd.sithMesPrdRoutingSummaryDetail.grid.sapChangedFlag',
        sortable: true,
        form: {
        type: 'select'
        ,options: [
                { value: '0', text: '未变化' },
                            { value: '1', text: '从未释放到已释放' },
                            { value: '2', text: '关键信息变更' },
                            { value: '3', text: '删除' }
            ]
        }
        },
        {
        key: 'description',
        label: 'label.sith.prd.sithMesPrdRoutingSummaryDetail.grid.description',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'remark',
        label: 'label.sith.prd.sithMesPrdRoutingSummaryDetail.grid.remark',
        sortable: true,
            isDetail: true,
        form: {
        type: 'textarea'
        }
        }
    ])}

const filter = {
    prdRoutingSummaryCodeFilter : "",
    mstLocationIdFilter : "",
    bufferHourFilter : "",
    transferHourFilter : "",
    sapChangedFlagFilter : "",
    descriptionFilter : ""
};

const fields = Object.freeze(Object.keys(newEntity()).map(i => 'entity.' + i));

const filterFields = Object.freeze(Object.keys(filter).map(i => 'filter.' + i));

const filterConfigs = [
        {
        key: 'prdRoutingSummaryCodeFilter',
        label: 'label.sith.prd.sithMesPrdRoutingSummaryDetail.filter.prdRoutingSummaryCode',
        disabled: false,
        form: {
        type: 'entityModalSelect'
            ,entity: 'sithMesPrdRoutingSummary'
            ,correspondingField: 'code'
                }
        },
        {
        key: 'mstLocationIdFilter',
        label: 'label.sith.prd.sithMesPrdRoutingSummaryDetail.filter.mstLocationId',
        disabled: false,
        form: {
        type: 'inputNumber'
                }
        },
        {
        key: 'bufferHourFilter',
        label: 'label.sith.prd.sithMesPrdRoutingSummaryDetail.filter.bufferHour',
        disabled: false,
        form: {
        type: 'input'
                }
        },
        {
        key: 'transferHourFilter',
        label: 'label.sith.prd.sithMesPrdRoutingSummaryDetail.filter.transferHour',
        disabled: false,
        form: {
        type: 'input'
                }
        },
        {
        key: 'sapChangedFlagFilter',
        label: 'label.sith.prd.sithMesPrdRoutingSummaryDetail.filter.sapChangedFlag',
        disabled: false,
        form: {
        type: 'select'
            ,showLabelSelectOne: true
         ,options: [
                { value: '0', text: '未变化' },
                { value: '1', text: '从未释放到已释放' },
                { value: '2', text: '关键信息变更' },
                { value: '3', text: '删除' }
            ]
        }
        },
        {
        key: 'descriptionFilter',
        label: 'label.sith.prd.sithMesPrdRoutingSummaryDetail.filter.description',
        disabled: false,
        form: {
        type: 'input'
                }
        }
];


    const entityFormConfigs = [
        {
        key: 'prdRoutingSummaryCode',
        label: 'label.sith.prd.sithMesPrdRoutingSummaryDetail.entity.prdRoutingSummaryCode',
        sortable: true,
        disabled: false,
        form: {
        type: 'entityModalSelect'
            ,required: true
            ,entity: 'sithMesPrdRoutingSummary'
            ,correspondingField: 'code'
                }
        },
        {
        key: 'mstLocationId',
        label: 'label.sith.prd.sithMesPrdRoutingSummaryDetail.entity.mstLocationId',
        sortable: true,
        disabled: false,
        form: {
        type: 'inputNumber'
            ,required: true
                }
        },
        {
        key: 'workHour',
        label: 'label.sith.prd.sithMesPrdRoutingSummaryDetail.entity.workHour',
        sortable: true,
        disabled: false,
        form: {
        type: 'inputNumber'
            ,required: true
                }
        },
        {
        key: 'seq',
        label: 'label.sith.prd.sithMesPrdRoutingSummaryDetail.entity.seq',
        sortable: true,
        disabled: false,
        form: {
        type: 'inputNumber'
            ,required: true
                }
        },
        {
        key: 'bufferHour',
        label: 'label.sith.prd.sithMesPrdRoutingSummaryDetail.entity.bufferHour',
        sortable: true,
        disabled: false,
        form: {
        type: 'input'
                }
        },
        {
        key: 'transferHour',
        label: 'label.sith.prd.sithMesPrdRoutingSummaryDetail.entity.transferHour',
        sortable: true,
        disabled: false,
        form: {
        type: 'input'
                }
        },
        {
        key: 'unit',
        label: 'label.sith.prd.sithMesPrdRoutingSummaryDetail.entity.unit',
        sortable: true,
        disabled: false,
        form: {
        type: 'input'
            ,required: true
                }
        },
        {
        key: 'quantity',
        label: 'label.sith.prd.sithMesPrdRoutingSummaryDetail.entity.quantity',
        sortable: true,
        disabled: false,
        form: {
        type: 'inputNumber'
            ,required: true
                }
        },
        {
        key: 'description',
        label: 'label.sith.prd.sithMesPrdRoutingSummaryDetail.entity.description',
        sortable: true,
        disabled: false,
        form: {
        type: 'textarea'
                }
        },
        {
        key: 'remark',
        label: 'label.sith.prd.sithMesPrdRoutingSummaryDetail.entity.remark',
        sortable: true,
        disabled: false,
        form: {
        type: 'textarea'
                }
        }
]

export {SithMesPrdRoutingSummaryDetail, newEntity, gridFields, fields, filterFields, filter, entityFormConfigs
, filterConfigs


}
